import ArrowDownGlyph from '../../../icons/ArrowDownGlyph';
import { type FlyoutThemeProps } from '../types/_theme';

import { FlyoutType } from '../_props';

const flyoutSubUlContainer = 'absolute invisible transform group-hover:visible';
const flyoutSelectedClasses = 'border-t-4 px-4';
const flyoutLiClasses = 'h-full xl:px-0';
const flyoutSelectedNotActiveClasses = 'border-t-blue-800 hover:border-t-blue-500';
const flyoutSelectedActiveClasses = 'border-t-blue-500';
const flyoutArrowGlyphClass = 'fill-white';
const flyoutLiSize = 'xl:w-28';
const flyoutSubUlThemeClasses = 'mt-1 bg-blue-800';
const flyoutSubLiThemeClasses = 'hover:bg-blue-500';
const flyoutSubLiCenter = '';
const flyoutSubLiEnd = '';
const flyoutSubLinkThemeClasses = 'text-xs xl:text-sm';

const flyoutIconProps: FlyoutType['iconProps'] = {
  bg: false,
  size: 'Glyph',
  className: flyoutArrowGlyphClass,
  options: {
    viewBox: '0 0 8 8',
    width: '6',
    height: '4',
  },
};

const flyoutBlogTheme = (_: FlyoutThemeProps) => ({
  flyoutSubUlContainer,
  flyoutSelectedClasses,
  flyoutLiClasses,
  flyoutSelectedActiveClasses,
  flyoutSelectedNotActiveClasses,
  flyoutArrowGlyphClass,
  flyoutLiSize,
  flyoutSubUlThemeClasses,
  flyoutSubLiThemeClasses,
  flyoutIconProps,
  flyoutSubLiCenter,
  flyoutSubLiEnd,
  ExpandMoreIcon: ArrowDownGlyph,
  flyoutSubLinkThemeClasses,
});

export default flyoutBlogTheme;
